<template>
  <div>
    <Accordion :title="item.SYARYO_MEI" class="accordion mb-2" type="2">
      <div class="section-child">
        <table class="table">
          <tr>
            <th><span>車両タイプ</span></th>
            <td>
              <span>{{ syaryoTypeKbnJson[item.SYARYO_TYPE_KBN] }}</span>
            </td>
          </tr>
          <tr v-if="item.SYARYO_TYPE_DETAIL !== undefined">
            <th><span>その他詳細</span></th>
            <td>
              <span>{{ item.SYARYO_TYPE_DETAIL }}</span>
            </td>
          </tr>
          <tr v-if="item.SYARYO_SHAPE_TYPE !== undefined">
            <th><span>形状</span></th>
            <td>
              <span>{{ syaryoShapeTypeJson[item.SYARYO_SHAPE_TYPE] }}</span>
            </td>
          </tr>
          <tr v-if="item.SYARYO_SHAPE_DETAIL !== undefined">
            <th><span>その他詳細</span></th>
            <td>
              <span>{{ item.SYARYO_SHAPE_DETAIL }}</span>
            </td>
          </tr>
          <tr v-if="item.SYARYO_MAKER_MEI !== undefined">
            <th><span>メーカー名</span></th>
            <td>
              <span>{{ item.SYARYO_MAKER_MEI }}</span>
            </td>
          </tr>
          <tr v-if="item.SYARYO_MEI !== undefined">
            <th><span>車名</span></th>
            <td>
              <span>{{ item.SYARYO_MEI }}</span>
            </td>
          </tr>
          <tr v-if="item.SYADAI_BANGO !== undefined">
            <th><span>車台番号</span></th>
            <td>
              <span>{{ item.SYADAI_BANGO }}</span>
            </td>
          </tr>
          <tr v-if="item.TOUROKU_BANGO !== undefined">
            <th><span>登録番号</span></th>
            <td>
              <span v-if="item.TOUROKU_BANGO">
                {{
                  item.TOUROKU_BANGO
                    ? item.TOUROKU_BANGO.replace(/ /g, '-')
                    : null
                }}
              </span>
            </td>
          </tr>
          <tr v-if="item.SYARYO_NAGASA !== undefined">
            <th><span>長さ・幅・高さ(cm)</span></th>
            <td>
              <label v-if="item.SYARYO_NAGASA">長さ</label>
              <span v-if="item.SYARYO_NAGASA">
                {{ item.SYARYO_NAGASA }}cm &nbsp;
              </span>
              <label v-if="item.SYARYO_HABA">幅</label>
              <span v-if="item.SYARYO_HABA">
                {{ item.SYARYO_HABA }}cm &nbsp;
              </span>
              <label v-if="item.SYARYO_TAKASA">高さ</label>
              <span v-if="item.SYARYO_TAKASA">
                {{ item.SYARYO_TAKASA }}cm &nbsp;
              </span>
            </td>
          </tr>
          <tr v-if="item.SYARYO_SEKISAIRYO !== undefined">
            <th><span>積載量・重量(kg)</span></th>
            <td>
              <label v-if="item.SYARYO_SEKISAIRYO">積載量</label>
              <span v-if="item.SYARYO_SEKISAIRYO">
                {{ item.SYARYO_SEKISAIRYO }}kg &nbsp;
              </span>
              <label v-if="item.SYARYO_JYURYO">重量</label>
              <span v-if="item.SYARYO_JYURYO">
                {{ item.SYARYO_JYURYO }}kg &nbsp;
              </span>
            </td>
          </tr>
          <tr v-if="item.KISYA_KANRI_BANGO !== undefined">
            <th><span>貴社管理番号</span></th>
            <td>
              <span>{{ item.KISYA_KANRI_BANGO }}</span>
            </td>
          </tr>
          <tr v-if="item.SHITADORI_FLG !== undefined">
            <th><span>下取り車両</span></th>
            <td>
              <span>
                {{ getText(ariNasiList, Number(item.SHITADORI_FLG)) }}
              </span>
            </td>
          </tr>
          <tr v-if="item.YUSOSAKI_KBN !== undefined">
            <th><span>下取り車両 輸送先</span></th>
            <td>
              <div>
                {{
                  getText(
                    isLease ? yusosakiLeaseList : yusosakiList,
                    Number(item.YUSOSAKI_KBN)
                  )
                }}
              </div>
              <div v-if="item.YUSOSAKI_FREE !== undefined">
                {{ item.YUSOSAKI_FREE }}
              </div>
            </td>
          </tr>
          <tr v-if="item.SOUFUBUTU_KBN !== undefined">
            <th><span>下取り車両 書類の送付物</span></th>
            <td>
              <label />
              <span>
                {{ getText(docSoufubutuList, item.SOUFUBUTU_KBN) }}
              </span>
            </td>
          </tr>
          <tr v-if="item.SHITADORI_SYARYO_TYPE_KBN !== undefined">
            <th><span>下取り車両タイプ</span></th>
            <td>
              <span>
                {{ convSyaryoType(item.SHITADORI_SYARYO_TYPE_KBN) }}
              </span>
            </td>
          </tr>
          <tr v-if="item.SHITADORI_SYARYO_MAKER_MEI !== undefined">
            <th><span>下取りメーカー名</span></th>
            <td>
              <span>{{ item.SHITADORI_SYARYO_MAKER_MEI }}</span>
            </td>
          </tr>
          <tr v-if="item.SHITADORI_SYARYO_MEI !== undefined">
            <th><span>下取り車名</span></th>
            <td>
              <span>{{ item.SHITADORI_SYARYO_MEI }}</span>
            </td>
          </tr>
          <tr v-if="item.SHITADORI_SYADAI_BANGO !== undefined">
            <th><span>下取り車台番号</span></th>
            <td>
              <span>{{ item.SHITADORI_SYADAI_BANGO }}</span>
            </td>
          </tr>
          <tr v-if="item.SHITADORI_TOUROKU_BANGO !== undefined">
            <th><span>下取り登録番号</span></th>
            <td>
              <span v-if="item.SHITADORI_TOUROKU_BANGO">
                {{
                  item.SHITADORI_TOUROKU_BANGO
                    ? item.SHITADORI_TOUROKU_BANGO.replace(/ /g, '-')
                    : null
                }}
              </span>
            </td>
          </tr>
          <tr>
            <th><span>車検の有無</span></th>
            <td>
              <span>{{ convAriNasiFlg(item.SYAKEN_FLG) }}</span>
            </td>
          </tr>
          <tr v-if="item.SYUPPIN_BANGO !== undefined">
            <th><span>出品番号</span></th>
            <td>
              <span>{{ item.SYUPPIN_BANGO }}</span>
            </td>
          </tr>
          <tr v-if="item.HANSYUTUKEN_URL !== undefined">
            <th><span>搬出券</span></th>
            <td>
              <span>{{ item.HANSYUTUKEN_URL ? 'あり' : '' }}</span>
            </td>
          </tr>
          <tr v-if="item.OTHER_FILE_LIST !== undefined">
            <th><span>その他ファイル</span></th>
            <ul v-if="item.OTHER_FILE_LIST.length">
              <li v-for="file in item.OTHER_FILE_LIST" :key="file.url">
                {{ file.name }}
              </li>
            </ul>
          </tr>
          <tr v-if="item.HANNYU_MEI !== undefined">
            <th><span>搬入名義</span></th>
            <td>
              <span>{{ item.HANNYU_MEI }}</span>
            </td>
          </tr>
          <tr v-if="item.ATSUKAI_MEI !== undefined">
            <th><span>扱い名</span></th>
            <td>
              <span>{{ item.ATSUKAI_MEI }}</span>
            </td>
          </tr>
          <tr v-if="item.MUKETI_MEI !== undefined">
            <th><span>向け地</span></th>
            <td>
              <span>{{ item.MUKETI_MEI }}</span>
            </td>
          </tr>
          <tr v-if="item.JISOU_KBN !== undefined">
            <th><span>自走してもよろしいですか？</span></th>
            <td>
              <span>{{ getText(jisouKbnList, Number(item.JISOU_KBN)) }}</span>
            </td>
          </tr>

          <tr v-if="item.CAR_CONDITIONS.is_self_run !== undefined">
            <th><span>公道を自力で自走できますか？</span></th>
            <td>
              <span>{{ yesNoFumeiJson[item.CAR_CONDITIONS.is_self_run] }}</span>
            </td>
          </tr>
          <tr v-if="item.CAR_CONDITIONS.is_self_run_detail !== undefined">
            <th><span>自走できない理由</span></th>
            <td>
              <span>
                {{
                  carConditionNotSelfRunForReasonJson[
                    item.CAR_CONDITIONS.is_self_run_detail
                  ]
                }}
              </span>
            </td>
          </tr>
          <tr v-if="item.CAR_CONDITIONS.is_roll_tire !== undefined">
            <th><span>タイヤは転がりますか？</span></th>
            <td>
              <span>
                {{ yesNoFumeiJson[item.CAR_CONDITIONS.is_roll_tire] }}
              </span>
            </td>
          </tr>
          <tr v-if="item.CAR_CONDITIONS.is_run_engine !== undefined">
            <th><span>エンジンはかかりますか？</span></th>
            <td>
              <span>
                {{ yesNoFumeiJson[item.CAR_CONDITIONS.is_run_engine] }}
              </span>
            </td>
          </tr>
          <tr v-if="item.CAR_CONDITIONS.is_self_run_detail_other !== undefined">
            <th><span>その他詳細</span></th>
            <td>
              <span>{{ item.CAR_CONDITIONS.is_self_run_detail_other }}</span>
            </td>
          </tr>
          <tr v-if="item.CAR_CONDITIONS.is_studless !== undefined">
            <th><span>スタッドレスタイヤ装着済です</span></th>
            <td>
              <span>{{ yesNoFumeiJson[item.CAR_CONDITIONS.is_studless] }}</span>
            </td>
          </tr>
          <tr v-if="item.CAR_CONDITIONS.is_run_air_conditioner !== undefined">
            <th><span>エアコン故障・不良車両ではありません</span></th>
            <td>
              <span>
                {{ yesNoFumeiJson[item.CAR_CONDITIONS.is_run_air_conditioner] }}
              </span>
            </td>
          </tr>
          <tr v-if="item.CAR_CONDITIONS.is_custom !== undefined">
            <th><span>車両改造有無</span></th>
            <td>
              <span>{{ isCarCustomJson[item.CAR_CONDITIONS.is_custom] }}</span>
            </td>
          </tr>
          <tr v-if="item.CAR_CONDITIONS.is_custom_details !== undefined">
            <th><span>該当する改造・架装</span></th>
            <td>
              <span
                v-for="custom_detail in item.CAR_CONDITIONS.is_custom_details"
                :key="custom_detail"
              >
                {{ carCustomJson[custom_detail] }}
              </span>
            </td>
          </tr>
          <tr v-if="item.CAR_CONDITIONS.minimum_height !== undefined">
            <th><span>最低地上高</span></th>
            <td>
              <span>{{ item.CAR_CONDITIONS.minimum_height }} cm</span>
            </td>
          </tr>
          <tr v-if="item.CAR_CONDITIONS.inch_up !== undefined">
            <th><span>アップしたインチ数</span></th>
            <td>
              <span>{{ item.CAR_CONDITIONS.inch_up }}</span>
            </td>
          </tr>
          <tr v-if="item.CAR_CONDITIONS.is_custom_detail_other !== undefined">
            <th><span>その他詳細</span></th>
            <td>
              <span>{{ item.CAR_CONDITIONS.is_custom_detail_other }}</span>
            </td>
          </tr>
          <tr v-if="item.CAR_CONDITIONS.is_expensive !== undefined">
            <th><span>高額車ですか？</span></th>
            <td>
              <span>
                {{ isExpensiveCarJson[item.CAR_CONDITIONS.is_expensive] }}
              </span>
            </td>
          </tr>
          <tr v-if="item.CAR_CONDITIONS.price !== undefined">
            <th><span>価格</span></th>
            <td>
              <span>{{ item.CAR_CONDITIONS.price }} 万円</span>
            </td>
          </tr>
          <tr v-if="item.CAR_CONDITIONS.is_classic !== undefined">
            <th><span>旧車ですか？</span></th>
            <td>
              <span>
                {{ isClassicCarJson[item.CAR_CONDITIONS.is_classic] }}
              </span>
            </td>
          </tr>
          <tr v-if="item.CAR_CONDITIONS.model_year !== undefined">
            <th><span>年式</span></th>
            <td>
              <span>{{ item.CAR_CONDITIONS.model_year }}</span>
            </td>
          </tr>
          <tr v-if="item.CAR_CONDITIONS.fuel_type !== undefined">
            <th><span>車両燃料</span></th>
            <td>
              <span>{{ carFuelJson[item.CAR_CONDITIONS.fuel_type] }}</span>
            </td>
          </tr>
          <tr v-if="item.MEIHEN_KIBO_BI !== undefined">
            <th><span>登録希望日</span></th>
            <td>
              <span>{{ item.MEIHEN_KIBO_BI }}</span>
            </td>
          </tr>
          <tr v-if="item.MEIHEN_SYAKEN_KBN !== undefined">
            <th><span>車検残の有無</span></th>
            <td>
              <span>
                {{ getText(syakenList, Number(item.MEIHEN_SYAKEN_KBN)) }}
              </span>
            </td>
          </tr>
          <tr v-if="item.MEIHEN_KEI_FLG !== undefined">
            <th><span>軽自動車ですか？</span></th>
            <td>
              <span>{{ getText(yesNoList, Number(item.MEIHEN_KEI_FLG)) }}</span>
            </td>
          </tr>
          <tr v-if="item.MEIHEN_UNYU_SIKYOKU_SHIKU_MEI !== undefined">
            <th><span>管轄運輸支局・検査登録事務所</span></th>
            <td>
              <span>{{ item.MEIHEN_UNYU_SIKYOKU_SHIKU_MEI }}</span>
            </td>
          </tr>
          <tr v-if="item.MEIHEN_TOUROKU_KBN !== undefined">
            <th><span>登録種別</span></th>
            <td>
              <span>
                {{ getText(torokuKbnList, Number(item.MEIHEN_TOUROKU_KBN)) }}
              </span>
            </td>
          </tr>
          <tr v-if="item.MEIHEN_NUMBER_KBN !== undefined">
            <th><span>ナンバー種別</span></th>
            <td>
              <span>
                {{ getText(numberKbnList, Number(item.MEIHEN_NUMBER_KBN)) }}
              </span>
            </td>
          </tr>
          <tr v-if="item.MEIHEN_KIBO_NUMBER_FLG !== undefined">
            <th><span>希望番号</span></th>
            <td>
              <span>
                {{ getText(ariNasiList, Number(item.MEIHEN_KIBO_NUMBER_FLG)) }}
              </span>
            </td>
          </tr>
          <tr v-if="item.MEIHEN_KIBO_NUMBER_DAIKO_FLG !== undefined">
            <th><span>希望番号の申請代行を希望しますか？</span></th>
            <td>
              <span>
                {{
                  getText(
                    yesNoHopeList,
                    Number(item.MEIHEN_KIBO_NUMBER_DAIKO_FLG)
                  )
                }}
              </span>
            </td>
          </tr>
          <tr v-if="item.MEIHEN_KIBO_NUMBER !== undefined">
            <th><span>希望する番号</span></th>
            <td>
              <span>{{ item.MEIHEN_KIBO_NUMBER }}</span>
            </td>
          </tr>
          <tr v-if="item.MEIHEN_KIBO_NUMBER_ZUGARA_FLG !== undefined">
            <th><span>図柄入りナンバー</span></th>
            <td>
              <span>
                {{
                  getText(
                    yesNoHopeList,
                    Number(item.MEIHEN_KIBO_NUMBER_ZUGARA_FLG)
                  )
                }}
              </span>
            </td>
          </tr>
          <tr v-if="item.MEIHEN_KIBO_NUMBER_UKETUKE_BANGO !== undefined">
            <th><span>受付番号</span></th>
            <td>
              <span>{{ item.MEIHEN_KIBO_NUMBER_UKETUKE_BANGO }}</span>
            </td>
          </tr>
          <tr v-if="item.MEIHEN_KAZEI_KBN !== undefined">
            <th><span>課税対象</span></th>
            <td>
              <span>
                {{ getText(kazeiList, Number(item.MEIHEN_KAZEI_KBN)) }}
              </span>
            </td>
          </tr>
          <tr v-if="item.MEIHEN_SYOYUSYA_MEI !== undefined">
            <th><span>新所有者名</span></th>
            <td>
              <span>{{ item.MEIHEN_SYOYUSYA_MEI }}</span>
            </td>
          </tr>
          <tr v-if="item.MEIHEN_SIYOSYA_MEI !== undefined">
            <th><span>新使用者名</span></th>
            <td>
              <span>{{ item.MEIHEN_SIYOSYA_MEI }}</span>
            </td>
          </tr>
          <tr v-if="item.MEIHEN_SIYOSYA_MEI_KANA !== undefined">
            <th><span>新使用者名(ふりがな)</span></th>
            <td>
              <span>{{ item.MEIHEN_SIYOSYA_MEI_KANA }}</span>
            </td>
          </tr>
          <tr v-if="item.MEIHEN_SIYOSYA_TODO_MEI !== undefined">
            <th><span>新使用者 住所</span></th>
            <td>
              <span
                v-if="item.MEIHEN_SIYOSYA_YUBIN1 && item.MEIHEN_SIYOSYA_YUBIN2"
              >
                {{ item.MEIHEN_SIYOSYA_YUBIN1 }}-{{
                  item.MEIHEN_SIYOSYA_YUBIN2
                }}
                <br />
              </span>
              <span>
                {{ item.MEIHEN_SIYOSYA_TODO_MEI
                }}{{ item.MEIHEN_SIYOSYA_SHIKU_MEI
                }}{{ item.MEIHEN_SIYOSYA_BANCHI }}
              </span>
            </td>
          </tr>
          <tr v-if="item.MEIHEN_SIYOSYA_TEL !== undefined">
            <th><span>新使用者 TEL</span></th>
            <td>
              <span>{{ item.MEIHEN_SIYOSYA_TEL }}</span>
            </td>
          </tr>
          <tr v-if="item.MEIHEN_SIYOSYA_MAIL_ADDR !== undefined">
            <th><span>新使用者 メールアドレス</span></th>
            <td>
              <span>{{ item.MEIHEN_SIYOSYA_MAIL_ADDR }}</span>
            </td>
          </tr>
          <tr v-if="item.JYUMINHYO_FLG !== undefined">
            <th><span>住民票の住所と異なりますか？</span></th>
            <td>
              <span>
                {{ getText(yesNoList, Number(item.JYUMINHYO_FLG)) }}
              </span>
            </td>
          </tr>
          <tr v-if="item.JYUMINHYO_TODO_MEI !== undefined">
            <th><span>住民票 住所</span></th>
            <td>
              <span v-if="item.JYUMINHYO_YUBIN1 && item.JYUMINHYO_YUBIN2">
                {{ item.JYUMINHYO_YUBIN1 }}-{{ item.JYUMINHYO_YUBIN2 }}
                <br />
              </span>
              <span>
                {{ item.JYUMINHYO_TODO_MEI }}{{ item.JYUMINHYO_SHIKU_MEI
                }}{{ item.JYUMINHYO_BANCHI }}
              </span>
            </td>
          </tr>
          <tr v-if="item.MEIHEN_SYAKOSYO_DAIKO_KBN !== undefined">
            <th><span>車庫証明取得代行</span></th>
            <td>
              <span>
                {{
                  getText(
                    syakoDaikoList,
                    Number(item.MEIHEN_SYAKOSYO_DAIKO_KBN)
                  )
                }}
              </span>
            </td>
          </tr>
          <tr v-if="item.MEIHEN_JIBAISEKI_KBN !== undefined">
            <th><span>自賠責</span></th>
            <td>
              <span>
                {{ getText(jibaisekiList, Number(item.MEIHEN_JIBAISEKI_KBN)) }}
              </span>
            </td>
          </tr>
          <tr v-if="item.MEIHEN_JIDOSYA_ZEI !== undefined">
            <th><span>自動車税種別割額</span></th>
            <td>
              <span>
                {{ numberWithDelimiter(item.MEIHEN_JIDOSYA_ZEI) }}
              </span>
            </td>
          </tr>
          <tr v-if="item.MEIHEN_JIDOSYA_SYUTOKU_ZEI !== undefined">
            <th><span>環境性能割額</span></th>
            <td>
              <span>
                {{ numberWithDelimiter(item.MEIHEN_JIDOSYA_SYUTOKU_ZEI) }}
              </span>
            </td>
          </tr>
          <tr v-if="item.MEIHEN_JYURYOU_ZEI !== undefined">
            <th><span>重量税額</span></th>
            <td>
              <span>
                {{ numberWithDelimiter(item.MEIHEN_JYURYOU_ZEI) }}
              </span>
            </td>
          </tr>
          <tr v-if="item.BIKO !== undefined">
            <th><span>車両備考</span></th>
            <td>
              <span>{{ item.BIKO }}</span>
            </td>
          </tr>
        </table>

        <table v-if="!isMeihen" class="table">
          <tr v-if="item.SEISOU_FLG !== undefined">
            <th><span>清掃サービス</span></th>
            <td>
              <span>{{ getText(yesNoHopeList, Number(item.SEISOU_FLG)) }}</span>
            </td>
          </tr>
          <tr v-if="item.SEISOU_KBN !== undefined">
            <th><span>清掃内容</span></th>
            <td>
              <span>{{ getText(seisoList, Number(item.SEISOU_KBN)) }}</span>
            </td>
          </tr>
          <tr v-if="item.NUMBER_PLATE_FLG !== undefined">
            <th><span>ナンバープレート別送サービスのご希望</span></th>
            <td>
              <span>
                {{ getText(yesNoHopeList, Number(item.NUMBER_PLATE_FLG)) }}
              </span>
            </td>
          </tr>
          <tr v-if="item.NUMBER_PLATE_MEI !== undefined">
            <th><span>名称（ナンバープレート）</span></th>
            <td>
              <span>{{ item.NUMBER_PLATE_MEI }}</span>
            </td>
          </tr>
          <tr v-if="item.NUMBER_PLATE_TODO_MEI !== undefined">
            <th><span>住所（ナンバープレート）</span></th>
            <td>
              <span v-if="item.NUMBER_PLATE_YUBIN1 && item.NUMBER_PLATE_YUBIN2">
                {{ item.NUMBER_PLATE_YUBIN1 }}-{{ item.NUMBER_PLATE_YUBIN2 }}
                <br />
              </span>
              <span>
                {{ item.NUMBER_PLATE_TODO_MEI }}{{ item.NUMBER_PLATE_SHIKU_MEI
                }}{{ item.NUMBER_PLATE_BANCHI }}
              </span>
            </td>
          </tr>
          <tr v-if="item.NUMBER_PLATE_SAKI_TEL !== undefined">
            <th><span>TEL（ナンバープレート）</span></th>
            <td>
              <span>{{ item.NUMBER_PLATE_SAKI_TEL }}</span>
            </td>
          </tr>
        </table>
      </div>
    </Accordion>

    <section class="col-md-6 p-3" id="trial-calc">
      <div v-if="Number(item.calc.result_code)">
        <h4 class="ml-3"><b>※別途お見積もり</b></h4>
      </div>
      <div v-else class="row">
        <div class="col-12 bold">
          <div class="row">
            <h4 class="col-6"><b>納期目安</b></h4>
            <h4 class="col-6">
              <b>{{ item.calc.result_noki }}</b>
            </h4>
          </div>
          <div class="row">
            <h4 class="col-6"><b>お見積もり概算</b></h4>
            <h4 class="col-6">
              <b>{{ separateComma(item.calc.result_price) }}円</b>
              <span class="f-size-12">（税別）</span>
            </h4>
          </div>
        </div>
        <div v-if="item.calc.result_uchiwake" class="ml-3 px-3 mt-2 col-10">
          <b>内訳</b>
          <div
            v-for="(uchiwake, index) in item.calc.result_uchiwake"
            :key="index"
            class="row"
          >
            <div class="col-6">{{ uchiwake.name }}</div>
            <div
              v-if="isMeihen && !item.calc.isAdjustment && uchiwake.price"
              class="col-6"
            >
              {{ Number(uchiwake.price).toLocaleString() }}円
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4 ml-2 f-size-14">
        <span>※納期は変動することがございます。</span>
        <br />
        <span>
          ※車両状態、その他の条件によって金額が変動することがございます。
        </span>
        <br />
        <span v-if="Number(item.SEISOU_FLG)">
          ※清掃代は別途実費請求となります。
        </span>
        <div v-if="isMeihen">
          <span>
            ※各種税金、自賠責保険、ナンバー代、印紙、証紙代は別途必要です。
          </span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Accordion from '@/components/utils/Accordion';
import Mixin from '../mixin/Mixin';

export default {
  name: 'ConfirmSyaryo',
  components: {
    Accordion,
  },
  mixins: [Mixin],

  props: {
    /** 車両データ */
    item: {
      type: Object,
      default: null,
    },

    /** 入力データ */
    form: {
      type: Object,
      default: null,
    },
  },

  computed: {
    /** 名変か判定する */
    isMeihen() {
      return this.form.MEIHEN_FLG
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
table
  margin: 0
  th
    background: $baseBlueColor
    color: #fff
    width: 32%
  td
    width: 68%
section#trial-calc
  margin: 20px auto
  background: $baseGrayColor
  border: 5px solid $baseBlueColor
  .result-message
    font-size: 24px
  @include sp
    width: 95%
    .result-message
      font-size: 15px
</style>



// WEBPACK FOOTER //
// src/components/order/ConfirmSyaryo.vue